import React from 'react';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from 'shared/utils/translation';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { format, isValid } from 'date-fns';
import { ResumeEmployment } from 'talent_matching/types';

const t = withLocalePrefix('talent_matching.table');

type LatestEmployment = {
  company_name: string;
  title: string;
  start_date: string;
  end_date: string | null;
};

type Employment = ResumeEmployment | LatestEmployment | undefined | null;

type Props = {
  title: string;
  company: string;
  latestEmployment: LatestEmployment | null;
  resumeEmployment: ResumeEmployment | undefined;
};

const CompanyTitleField = ({
  title,
  company,
  latestEmployment,
  resumeEmployment,
}: Props) => {
  const renderLabel = () => {
    const employment: Employment = latestEmployment || resumeEmployment;
    if (employment) {
      const companyName =
        (employment as LatestEmployment).company_name ||
        (employment as ResumeEmployment).employer;
      const formatMonthYear = (value: string) =>
        isValid(new Date(value)) ? format(new Date(value), 'LLL yyyy') : '';
      const startDate = employment.start_date
        ? formatMonthYear(employment.start_date)
        : '';
      const endDate = employment.end_date
        ? formatMonthYear(employment.end_date)
        : t('labels.current_employment');

      const durationString = startDate ? `${startDate} - ${endDate}` : endDate;

      return (
        <Stack spacing={0}>
          <SecondaryBody metadata>
            {t('labels.company_title', {
              title: employment.title,
              company: companyName,
            })}
          </SecondaryBody>
          <SecondaryBody metadata>{durationString}</SecondaryBody>
        </Stack>
      );
    }

    if (title && company) {
      return (
        <SecondaryBody metadata>
          {t('labels.company_title', { title, company })}
        </SecondaryBody>
      );
    }
    if (title) {
      return <SecondaryBody metadata>{title}</SecondaryBody>;
    }
    if (company) {
      return <SecondaryBody metadata>{company}</SecondaryBody>;
    }
    return null;
  };

  const label = renderLabel();
  if (!label) {
    return null;
  }

  return <div className="pii-blur">{label}</div>;
};

export default CompanyTitleField;
